import axios from "axios";
import axiosUtils from "@/util/axios-utils";

const CATALOG_AXIOS = axios.create({
    baseURL: "/api/catalog",
    timeout: 10000
});

axiosUtils.addUnauthorizedInterceptor(CATALOG_AXIOS);

export {CATALOG_AXIOS};
